import { render, staticRenderFns } from "./SpfTreeTable.vue?vue&type=template&id=e20bccc4&"
import script from "./SpfTreeTable.vue?vue&type=script&lang=ts&"
export * from "./SpfTreeTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports